module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loading) ? _c('span', [_c('p', [_vm._v("\n    Select the Wi-Fi network to connect to:\n  ")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.sendDone($event)
      }
    }
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "wifi_network"
    }
  }, [_vm._v("Network")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ssid_select),
      expression: "ssid_select"
    }],
    attrs: {
      "id": "wifi_network"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ssid_select = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "select"
    }
  }, [_vm._v("Select...")]), _vm._v(" "), _vm._l((_vm.formattedNetworks), function(network) {
    return _c('option', {
      domProps: {
        "value": network
      }
    }, [_vm._v("\n            " + _vm._s(network.ssid) + " - " + _vm._s(network.encryption) + " (" + _vm._s(network.signalQuality) + "%)\n          ")])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other/hidden network")])], 2)])]), _vm._v(" "), (_vm.ssid_select === 'other') ? _c('div', [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "wifi_ssid"
    }
  }, [_vm._v("Wi-Fi SSID")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.ssid_input),
      expression: "ssid_input",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "id": "wifi_ssid",
      "type": "text",
      "placeholder": "SSID",
      "maxLength": "32",
      "required": ""
    },
    domProps: {
      "value": (_vm.ssid_input)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ssid_input = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help"
  }, [_vm._v("Required.")])])]) : _vm._e(), _vm._v(" "), (typeof _vm.ssid_select === 'object' && _vm.ssid_select.encryption !== 'Open' || _vm.ssid_select === 'other') ? _c('div', [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "wifi_password"
    }
  }, [_vm._v("Wi-Fi password")]), _vm._v(" "), _c('p', {
    staticClass: "control is-grouped"
  }, [(_vm.passwordClearText) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "autocapitalize": "none",
      "id": "wifi_password",
      "placeholder": "Password",
      "maxLength": "64"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "id": "wifi_password",
      "placeholder": "Password",
      "maxLength": "64"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordClearText),
      expression: "passwordClearText"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.passwordClearText) ? _vm._i(_vm.passwordClearText, null) > -1 : (_vm.passwordClearText)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.passwordClearText,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.passwordClearText = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.passwordClearText = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.passwordClearText = $$c
        }
      }
    }
  }), _vm._v(" Show password\n        ")])]), _vm._v(" "), _c('span', {
    staticClass: "help"
  }, [_vm._v("Optional. Leave blank if open network.")]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "submit",
      "disabled": !_vm.formIsValid
    }
  }, [_vm._v("Next")])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-977dea36"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/steps/Wifi.vue
// module id = 60
// module chunks = 0